import {appUrl} from '@frontend/AppUrl'
import {trans} from '@frontend/helpers'
import {Link} from 'react-router-dom'
import {AppConfig} from '../../../AppConfig'

// Навигация по секциям сервиса для подвала.
export function FooterNavigationForAppSections() {

    return (
        <nav className="footer-links fs-7 d-flex flex-column flex-sm-row flex-wrap align-items-stretch justify-content-md-start justify-content-around">
            <div className="text-center text-sm-start">
                <div className="fw-600">
                    {trans().common.footer.about_us}
                </div>
                <div className="mt-2 mt-md-3">
                    <ul className="list-unstyled">
                        <li>
                            <Link to={appUrl().about}>
                                {trans().common.footer.about_project}
                            </Link>
                        </li>
                        {AppConfig.features.news !== false && (
                            <li>
                                <Link to={appUrl().news.list}>
                                    {trans().common.footer.news}
                                </Link>
                            </li>
                        )}
                        <li>
                            <Link to={appUrl().support.index}>
                                {trans().common.footer.questions_and_answers}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="ms-sm-7 ps-sm-3 text-center text-sm-start">
                <div className="fw-600">
                    {trans().common.footer.advertisements}
                </div>
                <div className="mt-2 mt-md-3">
                    <ul className="list-unstyled">
                        <li>
                            <Link to={appUrl().ads.all}>
                                {trans().common.footer.promo_and_shops}
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}
